(function () {
  'use strict';

  if (window.SNShoppableStories) {
    window.SNShoppableStories.initAll();
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var players = new Map();
  var roots = new Set();
  var activeShell = null;
  var autoplayFrame = 0;

  function activeVideo(shell) {
    if (!shell) return null;
    var preferred = shell.querySelector(mobileQuery.matches ? '[data-sn-video-mobile]' : '[data-sn-video-desktop]');
    var fallback = shell.querySelector(mobileQuery.matches ? '[data-sn-video-desktop]' : '[data-sn-video-mobile]');
    shell.querySelectorAll('[data-sn-performance-video]').forEach(function (video) {
      video.classList.toggle('is-active-video', video === (preferred || fallback));
    });
    return preferred || fallback;
  }

  function inViewport(shell) {
    if (!shell || !shell.isConnected || document.hidden || !shell.getClientRects().length) return false;
    var rect = shell.getBoundingClientRect();
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function connectionAllowsAutoplay() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    return !/(^|-)2g/.test(connection.effectiveType || '');
  }

  function setState(record, state) {
    if (!record || !record.shell) return;
    var card = record.shell.closest('[data-sn-video-card]') || record.shell;
    card.classList.toggle('is-loading', state === 'loading');
    card.classList.toggle('is-playing', state === 'playing');
    record.shell.classList.toggle('has-video-error', state === 'error');
    var button = record.shell.querySelector('[data-sn-video-toggle]');
    if (!button) return;
    var playing = state === 'playing';
    button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    button.setAttribute('aria-label', playing ? record.root.dataset.snPauseLabel : record.root.dataset.snPlayLabel);
  }

  function formatDuration(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) return '';
    var minutes = Math.floor(seconds / 60);
    var remaining = Math.floor(seconds % 60);
    return minutes + ':' + String(remaining).padStart(2, '0');
  }

  function updateDuration(record, video) {
    var badge = record.shell.querySelector('[data-sn-video-duration]');
    if (!badge || !video) return;
    var value = formatDuration(video.duration);
    if (!value) return;
    badge.textContent = value;
    badge.hidden = false;
  }

  function selectBestSource(video, shell) {
    var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-sn-src]'));
    if (!sources.length) return null;
    var mp4 = sources.filter(function (source) {
      return /video\/mp4/i.test(source.getAttribute('type') || '') || /\.mp4(?:$|[?#])/i.test(source.dataset.snSrc || '');
    });
    var candidates = mp4.length ? mp4 : sources;
    var dpr = Math.min(2, Math.max(1, window.devicePixelRatio || 1));
    var targetWidth = Math.max(280, Math.ceil(shell.clientWidth * dpr));
    var targetHeight = Math.max(280, Math.ceil(shell.clientHeight * dpr));
    var measured = candidates.map(function (source) {
      return {
        node: source,
        width: parseInt(source.dataset.snWidth, 10) || 0,
        height: parseInt(source.dataset.snHeight, 10) || 0
      };
    });
    var sufficient = measured.filter(function (item) {
      return item.width >= targetWidth && item.height >= targetHeight;
    }).sort(function (a, b) {
      return (a.width * a.height) - (b.width * b.height);
    });
    if (sufficient.length) return sufficient[0].node;
    measured.sort(function (a, b) {
      return (b.width * b.height) - (a.width * a.height);
    });
    return measured[0].node;
  }

  function syncResponsiveFrame(record) {
    var video = activeVideo(record.shell);
    if (!video) return null;
    if (record.activeVideo === video) return video;
    record.activeVideo = video;
    record.frameToken += 1;
    if (video.dataset.snFramePainted === 'true') {
      record.shell.classList.add('is-video-visible', 'is-poster-hidden', 'has-painted-frame');
    } else {
      record.shell.classList.remove('is-video-visible', 'is-poster-hidden', 'has-painted-frame');
    }
    record.shell.classList.remove('has-video-error');
    return video;
  }

  function revealPaintedFrame(record, video) {
    if (!record || !video || video.dataset.snFramePainted === 'true') return;
    var token = ++record.frameToken;
    var commit = function () {
      if (token !== record.frameToken || activeVideo(record.shell) !== video || !record.shell.isConnected) return;
      video.dataset.snFramePainted = 'true';
      record.shell.classList.add('is-video-visible', 'has-painted-frame');
      window.requestAnimationFrame(function () {
        if (token === record.frameToken && activeVideo(record.shell) === video) {
          record.shell.classList.add('is-poster-hidden');
        }
      });
    };
    if (typeof video.requestVideoFrameCallback === 'function') {
      video.requestVideoFrameCallback(commit);
      return;
    }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(commit);
    });
  }

  function hydrate(record) {
    var video = syncResponsiveFrame(record);
    if (!video) return null;
    if (video.dataset.snHydrated === 'true') return video;
    setState(record, 'loading');
    var source = selectBestSource(video, record.shell);
    if (!source || !source.dataset.snSrc) {
      setState(record, 'error');
      return null;
    }
    video.src = source.dataset.snSrc;
    video.dataset.snSelectedWidth = source.dataset.snWidth || '0';
    video.dataset.snSelectedHeight = source.dataset.snHeight || '0';
    video.dataset.snHydrated = 'true';
    video.preload = 'metadata';
    video.load();
    return video;
  }

  function pause(record, preserveManual) {
    if (!record) return;
    record.shell.querySelectorAll('[data-sn-performance-video]').forEach(function (video) {
      if (!video.paused) video.pause();
    });
    if (!preserveManual) record.manual = false;
    if (activeShell === record.shell) activeShell = null;
    setState(record, 'paused');
  }

  function pauseAll(exceptRecord) {
    players.forEach(function (record) {
      if (record !== exceptRecord) pause(record, false);
    });
  }

  function play(record, manual) {
    if (!record || !record.shell.isConnected || !inViewport(record.shell)) return;
    var video = hydrate(record);
    if (!video) return;
    pauseAll(record);
    record.userPaused = false;
    record.manual = Boolean(manual);
    activeShell = record.shell;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        if (activeShell === record.shell) activeShell = null;
        record.manual = false;
        setState(record, video.readyState > 1 ? 'paused' : 'ready');
      });
    }
  }

  function scheduleAutoplay() {
    if (autoplayFrame) return;
    autoplayFrame = window.requestAnimationFrame(function () {
      autoplayFrame = 0;
      if (document.hidden || reducedMotion.matches || !connectionAllowsAutoplay()) return;

      var manualRecord = null;
      players.forEach(function (record) {
        var video = activeVideo(record.shell);
        if (record.manual && record.visible && video && !video.paused) manualRecord = record;
      });
      if (manualRecord) return;

      var best = null;
      players.forEach(function (record) {
        if (!record.visible || record.userPaused || record.root.dataset.snAutoplay !== 'true') return;
        if (!best || record.ratio > best.ratio || (record.ratio === best.ratio && record.distance < best.distance)) best = record;
      });
      if (!best) return;
      var bestVideo = activeVideo(best.shell);
      if (bestVideo && bestVideo.paused) play(best, false);
    });
  }

  function bindVideo(record, video) {
    if (!video || video.dataset.snStoryBound === 'true') return;
    video.dataset.snStoryBound = 'true';
    video.addEventListener('loadedmetadata', function () { updateDuration(record, video); });
    video.addEventListener('loadeddata', function () { setState(record, video.paused ? 'ready' : 'playing'); });
    video.addEventListener('canplay', function () { setState(record, video.paused ? 'ready' : 'playing'); });
    video.addEventListener('play', function () {
      pauseAll(record);
      activeShell = record.shell;
      setState(record, 'playing');
    });
    video.addEventListener('playing', function () {
      setState(record, 'playing');
      revealPaintedFrame(record, video);
    });
    video.addEventListener('pause', function () {
      if (activeShell === record.shell) activeShell = null;
      setState(record, 'paused');
    });
    video.addEventListener('ended', function () {
      record.manual = false;
      if (activeShell === record.shell) activeShell = null;
      setState(record, 'paused');
      scheduleAutoplay();
    });
    video.addEventListener('error', function () {
      if (activeShell === record.shell) activeShell = null;
      setState(record, 'error');
    });
  }

  function bindPlayer(root, shell) {
    if (!shell || players.has(shell)) return;
    var record = { root: root, shell: shell, visible: false, ratio: 0, distance: Infinity, userPaused: false, manual: false, activeVideo: null, frameToken: 0 };
    players.set(shell, record);
    shell.querySelectorAll('[data-sn-performance-video]').forEach(function (video) { bindVideo(record, video); });
    syncResponsiveFrame(record);

    if ('IntersectionObserver' in window) {
      record.prefetchObserver = new IntersectionObserver(function (entries) {
        if (connectionAllowsAutoplay() && entries.some(function (entry) { return entry.isIntersecting; })) hydrate(record);
      }, { rootMargin: '260px 0px', threshold: 0.01 });
      record.prefetchObserver.observe(shell);

      record.visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var rect = entry.boundingClientRect;
          record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          record.ratio = entry.intersectionRatio;
          record.distance = Math.abs((rect.top + rect.bottom) / 2 - window.innerHeight / 2);
          if (!record.visible) pause(record, false);
        });
        scheduleAutoplay();
      }, { threshold: [0, 0.2, 0.35, 0.5, 0.75, 1] });
      record.visibilityObserver.observe(shell);
    } else {
      record.visible = inViewport(shell);
      if (record.visible) hydrate(record);
    }
  }

  function disposePlayer(shell) {
    var record = players.get(shell);
    if (!record) return;
    record.prefetchObserver && record.prefetchObserver.disconnect();
    record.visibilityObserver && record.visibilityObserver.disconnect();
    pause(record, false);
    players.delete(shell);
  }

  function nearestCard(rail) {
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sn-video-card]'));
    if (!cards.length) return { index: 0, cards: cards };
    var railBox = rail.getBoundingClientRect();
    var start = railBox.left;
    var bestIndex = 0;
    var bestDistance = Infinity;
    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - start);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });
    return { index: bestIndex, cards: cards };
  }

  function updateNavigation(root) {
    var rail = root.querySelector('[data-sn-video-rail]');
    if (!rail) return;
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var previous = root.querySelector('[data-sn-rail-previous]');
    var next = root.querySelector('[data-sn-rail-next]');
    if (previous) previous.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
    var nearest = nearestCard(rail);
    root.querySelectorAll('[data-sn-video-dot]').forEach(function (dot, index) {
      if (index === nearest.index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function scrollToIndex(root, index) {
    var rail = root.querySelector('[data-sn-video-rail]');
    if (!rail) return;
    var cards = rail.querySelectorAll('[data-sn-video-card]');
    var card = cards[Math.max(0, Math.min(cards.length - 1, index))];
    if (!card) return;
    rail.scrollTo({ left: card.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }

  function moveRail(root, direction) {
    var rail = root.querySelector('[data-sn-video-rail]');
    if (!rail) return;
    var nearest = nearestCard(rail);
    scrollToIndex(root, nearest.index + direction);
  }

  function bindDrag(root, rail) {
    if (!rail || rail.dataset.snDragBound === 'true') return;
    rail.dataset.snDragBound = 'true';
    var drag = null;

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('a,button,input,select,textarea,label')) return;
      drag = { id: event.pointerId, startX: event.clientX, startScroll: rail.scrollLeft, moved: false };
      rail.classList.add('is-dragging');
      rail.setPointerCapture && rail.setPointerCapture(event.pointerId);
    });
    rail.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var delta = event.clientX - drag.startX;
      if (Math.abs(delta) > 4) drag.moved = true;
      rail.scrollLeft = drag.startScroll - delta;
    });
    function finish(event) {
      if (!drag || (event && drag.id !== event.pointerId)) return;
      rail.classList.remove('is-dragging');
      drag = null;
      updateNavigation(root);
    }
    rail.addEventListener('pointerup', finish);
    rail.addEventListener('pointercancel', finish);
    rail.addEventListener('lostpointercapture', finish);
  }

  function openQuickAddSheet() {
    document.documentElement.classList.add('sn-shoppable-quickadd-active');
    window.setTimeout(function () {
      var modal = document.getElementById('QuickAddStandard');
      if (!modal || modal.dataset.snSheetObserved === 'true') return;
      modal.dataset.snSheetObserved = 'true';
      new MutationObserver(function () {
        if (!modal.hasAttribute('open')) document.documentElement.classList.remove('sn-shoppable-quickadd-active');
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }, 0);
  }

  function init(root) {
    if (!root) return;
    roots.add(root);
    root.querySelectorAll('[data-sn-player]').forEach(function (shell) { bindPlayer(root, shell); });
    var rail = root.querySelector('[data-sn-video-rail]');
    bindDrag(root, rail);

    if (root.dataset.snEventsBound !== 'true') {
      root.dataset.snEventsBound = 'true';
      root.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-sn-quick-add-opener]')) openQuickAddSheet();
      });
      root.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-sn-video-toggle]');
        if (toggle && root.contains(toggle)) {
          event.preventDefault();
          var shell = toggle.closest('[data-sn-player]');
          var record = players.get(shell);
          var video = activeVideo(shell);
          if (!record || !video) return;
          if (video.paused) play(record, true);
          else {
            record.userPaused = true;
            pause(record, true);
          }
          return;
        }

        var sound = event.target.closest('[data-sn-video-sound]');
        if (sound && root.contains(sound)) {
          event.preventDefault();
          event.stopPropagation();
          var soundShell = sound.closest('[data-sn-player]');
          var soundRecord = players.get(soundShell);
          var soundVideo = hydrate(soundRecord);
          if (!soundVideo) return;
          soundVideo.muted = !soundVideo.muted;
          sound.setAttribute('aria-pressed', soundVideo.muted ? 'false' : 'true');
          sound.setAttribute('aria-label', root.dataset.snSoundLabel);
          if (soundVideo.paused) play(soundRecord, true);
          return;
        }

        var previous = event.target.closest('[data-sn-rail-previous]');
        var next = event.target.closest('[data-sn-rail-next]');
        if (previous || next) {
          event.preventDefault();
          moveRail(root, previous ? -1 : 1);
          return;
        }

        var dot = event.target.closest('[data-sn-video-dot]');
        if (dot && root.contains(dot)) {
          event.preventDefault();
          scrollToIndex(root, parseInt(dot.dataset.snVideoDot, 10) || 0);
          return;
        }

        if (event.target.closest('[data-sn-quick-add-opener]')) openQuickAddSheet();
      });
      if (rail) {
        var scrollFrame = 0;
        rail.addEventListener('scroll', function () {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(function () {
            scrollFrame = 0;
            updateNavigation(root);
          });
        }, { passive: true });
        rail.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveRail(root, event.key === 'ArrowLeft' ? -1 : 1);
        });
      }
    }

    updateNavigation(root);
    scheduleAutoplay();
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-sn-video-shop]')) init(context);
    context.querySelectorAll && context.querySelectorAll('[data-sn-video-shop]').forEach(init);
  }

  function refreshResponsivePlayers() {
    players.forEach(function (record) {
      pause(record, false);
      syncResponsiveFrame(record);
      if (record.visible) hydrate(record);
    });
    roots.forEach(updateNavigation);
    scheduleAutoplay();
  }

  window.SNShoppableStories = { init: init, initAll: initAll, pauseAll: pauseAll };
  window.SNShoppableVideos = window.SNShoppableStories;

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-sn-video-shop]') ? event.target : event.target.querySelector('[data-sn-video-shop]');
    if (!root) return;
    root.querySelectorAll('[data-sn-player]').forEach(disposePlayer);
    roots.delete(root);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    roots.forEach(function (root) {
      var card = root.querySelector('[data-sn-block-id="' + blockId + '"]');
      if (!card) return;
      var index = parseInt(card.dataset.snSlideIndex, 10) || 0;
      scrollToIndex(root, index);
    });
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pauseAll();
    else scheduleAutoplay();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.documentElement.classList.remove('sn-shoppable-quickadd-active');
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('#QuickAddStandard .quick-add-modal__toggle, #QuickAddStandard #Modal-Overlay')) {
      document.documentElement.classList.remove('sn-shoppable-quickadd-active');
    }
  });
  if (document.body) {
    document.body.addEventListener('modalClosed', function () {
      document.documentElement.classList.remove('sn-shoppable-quickadd-active');
    });
  }
  window.addEventListener('pagehide', function () { pauseAll(); });
  window.addEventListener('resize', function () {
    window.clearTimeout(window.SNShoppableStories.resizeTimer);
    window.SNShoppableStories.resizeTimer = window.setTimeout(refreshResponsivePlayers, 120);
  });
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', refreshResponsivePlayers);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', function () {
    if (reducedMotion.matches) pauseAll();
    else scheduleAutoplay();
  });
  document.addEventListener('sn:market-change', function () { pauseAll(); });
  document.addEventListener('sn:market-invalidated', function () { pauseAll(); });

  initAll();
})();
